import { baseServiceRequest } from "@apis/baseServiceRequest"
import {
  accountStatuses,
  accountStatusReasons,
  contactLanguages,
  contactTypes,
  defaultDispositions,
  resubmitDispositions,
  orderStatuses,
  orderStatusReasons,
  phoneNumberTypes,
  revenueClasses,
  states,
  businessTitles,
  accountHolderRelationship,
  caseAssignmentGroups,
} from "./sharedData"
import type { IValueLabel, IRejectStatus } from "./types"
import type { IContactDisposition } from "@apis/prospects/types"

export const getAccountStatuses = async (): Promise<IValueLabel[]> => {
  return Promise.resolve(accountStatuses)
}
export const getAccountStatusReasons = async (): Promise<IValueLabel[]> => {
  return Promise.resolve(accountStatusReasons)
}
export const getOrderStatuses = async (): Promise<IValueLabel[]> => {
  return Promise.resolve(orderStatuses)
}
export const getOrderReasons = async (): Promise<IValueLabel[]> => {
  return Promise.resolve(orderStatusReasons)
}
export const getRevenueClasses = async (): Promise<IValueLabel[]> => {
  return Promise.resolve(revenueClasses)
}
export const getStates = async (): Promise<IValueLabel[]> => {
  return Promise.resolve(states)
}
export const getContactTypes = async (): Promise<IValueLabel[]> => {
  return Promise.resolve(contactTypes)
}
export const getContactLanguages = async (): Promise<IValueLabel[]> => {
  return Promise.resolve(contactLanguages)
}

export const getPhoneNumberTypes = async (): Promise<IValueLabel[]> => {
  return Promise.resolve(phoneNumberTypes)
}

export const getContactDispositions = async (): Promise<
  IContactDisposition[]
> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/contacts/dispositions`,
  })
  return response.data
}

export const getDefaultDispositions = async (): Promise<IValueLabel[]> => {
  return Promise.resolve(defaultDispositions)
}

export const getResubmitDispositions = async (): Promise<IValueLabel[]> => {
  return Promise.resolve(resubmitDispositions)
}

export const getBusinessTitles = async (): Promise<IValueLabel[]> => {
  return Promise.resolve(businessTitles)
}

export const getAccountHolderRelationship = async (): Promise<
  IValueLabel[]
> => {
  return Promise.resolve(accountHolderRelationship)
}

export const getRejectStatus = async (): Promise<IRejectStatus[]> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/accounts/reject_statuses`,
  })
  return response.data
}

export const getCaseAssignmentGroups = async (): Promise<IValueLabel[]> => {
  return Promise.resolve(caseAssignmentGroups)
}
